/** Shared endorsement constants used by law-firm, PG, and approve-bonds surfaces (Phase 9.14B). */

export const ENDORSEMENT_NAME_CHANGE_TYPES = new Set([
  "Name_Change_Principal",
  "Name_Change_County",
  "Name_Change_Deceased_Ward_Beneficiary",
]);

export const isNameChangeEndorsement = (t) => ENDORSEMENT_NAME_CHANGE_TYPES.has(t);

export const DWB_LABEL_MAP = {
  Probate: { prefix: "Deceased Legal", alias: "Alias (Deceased)" },
  Guardianship: { prefix: "Ward", alias: "Ward Alias" },
  VA: { prefix: "Beneficiary", alias: "Beneficiary Alias" },
  Trustee: { prefix: "Full Legal Name", single: true },
};

export function getReleaseRiderUrl(bondOrType, bondId) {
  const bondType = typeof bondOrType === "object" ? bondOrType?.bond_type : bondOrType;
  const id = typeof bondOrType === "object" ? bondOrType?.bond_id : bondId;
  switch (bondType) {
    case "VA":
      return `/release-rider-va/${id}`;
    case "Trustee":
      return `/release-rider-trustee/${id}`;
    case "Probate":
      return `/release-rider-probate/${id}`;
    case "Blanket":
      return `/release-rider-blanket/${id}`;
    case "Guardianship":
    default:
      return `/release-rider-guardianship/${id}`;
  }
}
